import { StackProps } from "react-bootstrap";
import { ITestableComponentProps } from "../../../../shared/types/testing.types";

export interface IPageCounterProps
  extends StackProps,
    ITestableComponentProps {}

export const DefaultPageCounterProps: IPageCounterProps = {};
